import styled from 'styled-components';

export const TitleWrapper = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
`;
